import { ChainID } from '@ankr.com/chains-list';

import { chainsRoutesConfig } from 'domains/chains/routes';

export const useSubchainID = () => {
  const { netId } = chainsRoutesConfig.chainDetails.useParams();

  return netId as ChainID | undefined;
};
